/**
 * OPERIX AI ERP — Genel Kullanıcı Verilerini Silme Talimatları sayfası.
 *
 * URL: https://erp-fucan.com.tr/veri-silme
 * Meta App Review için gereken kamuya açık silme prosedürü.
 */
import { useEffect } from "react";

const LAST_UPDATED = "13 Ağustos 2026";
const CONTACT_EMAIL = "ugur@fucan.com.tr";
const MAIL_SUBJECT = "Veri Silme Talebi";
const MAIL_BODY =
  "Merhaba,%0D%0A%0D%0AACUTO 360 ve WhatsApp entegrasyonu kapsamında ilgili kişisel verilerimin silinmesini talep ediyorum.%0D%0A%0D%0A" +
  "- Ad Soyad:%0D%0A- Firma / Müşteri Adı:%0D%0A- Telefon Numarası (WhatsApp):%0D%0A- E-posta:%0D%0A%0D%0A" +
  "Talebimin en geç 30 gün içinde işleme alınmasını ve sonuç hakkında bilgilendirilmemi rica ederim.";

export default function DataDeletion() {
  useEffect(() => {
    document.title = "Kullanıcı Verilerini Silme Talimatları — ACUTO 360";
    const noindex = document.querySelector('meta[name="robots"]');
    if (noindex) noindex.setAttribute("content", "index, follow");
  }, []);

  const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(MAIL_SUBJECT)}&body=${MAIL_BODY}`;

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="data-deletion-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <header className="border-b pb-6 mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
            Kullanıcı Verilerini Silme Talimatları
          </h1>
          <p className="mt-2 text-sm text-slate-500">Son güncelleme: {LAST_UPDATED}</p>
        </header>

        <section className="space-y-6 leading-relaxed text-[15px]">
          <p>
            <strong>ACUTO 360</strong> (Fucan Personel Giyim) ve WhatsApp Business Platform entegrasyonu
            kapsamında sistemimizde bulunan kişisel verilerinizin silinmesini talep etme hakkına sahipsiniz.
          </p>

          <h2 className="text-lg font-semibold mt-6">Silme Talebinizi Nasıl İletirsiniz?</h2>
          <ol className="list-decimal ml-6 space-y-2">
            <li>
              <strong>{CONTACT_EMAIL}</strong> adresine e-posta gönderin.
            </li>
            <li>
              E-posta konusunu <em>"Veri Silme Talebi"</em> olarak yazın.
            </li>
            <li>
              E-posta içinde aşağıdaki bilgileri paylaşın:
              <ul className="list-disc ml-6 mt-1 space-y-0.5">
                <li>Adınız Soyadınız</li>
                <li>Firma / Müşteri adınız (varsa)</li>
                <li>Sisteme kayıtlı telefon numaranız (WhatsApp)</li>
                <li>Sisteme kayıtlı e-posta adresiniz (varsa)</li>
                <li>Silinmesini istediğiniz veri türleri (tüm veriler / sadece WhatsApp mesaj kayıtları / iletişim bilgileri vb.)</li>
              </ul>
            </li>
            <li>
              Talebinizi göndermek için hazır e-posta şablonunu kullanabilirsiniz:{" "}
              <a
                href={mailto}
                data-testid="data-deletion-mailto-btn"
                className="inline-block mt-2 bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold px-4 py-2 rounded-sm"
              >
                Silme Talebi E-postası Gönder
              </a>
            </li>
          </ol>

          <h2 className="text-lg font-semibold mt-8">İşlem Süreci ve Süre</h2>
          <ul className="list-disc ml-6 space-y-1">
            <li>Talebiniz, kimlik doğrulama sonrası <strong>en geç 30 gün</strong> içinde işleme alınır.</li>
            <li>Kişisel verileriniz aktif sistem veritabanından silinir. WhatsApp mesajlaşma geçmişiniz de kaldırılır.</li>
            <li>Yasal saklama zorunluluğu bulunan kayıtlar (fatura, muhasebe kayıtları) ilgili mevzuat süresi sonunda silinir.</li>
            <li>Silme işlemi tamamlandığında size bir onay e-postası gönderilir.</li>
          </ul>

          <h2 className="text-lg font-semibold mt-8">Yasal Saklama Zorunlulukları</h2>
          <p>
            Türk Ticaret Kanunu, Vergi Usul Kanunu ve KVKK kapsamında belirli kayıtları (fatura, sipariş
            belgeleri, muhasebe defterleri vb.) <strong>10 yıla kadar</strong> saklama yükümlülüğümüz vardır.
            Bu tür kayıtlar mevzuat süresi dolduğunda otomatik olarak silinir.
          </p>

          <h2 className="text-lg font-semibold mt-8">İletişim</h2>
          <p>
            Silme talebiniz veya diğer gizlilik konularındaki sorularınız için:
            <br />
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-emerald-700 underline font-semibold">
              {CONTACT_EMAIL}
            </a>
          </p>
          <p className="text-sm text-slate-600">
            Gizlilik politikamızın tamamı için:{" "}
            <a href="/gizlilik-politikasi" className="text-emerald-700 underline">Gizlilik Politikası</a>
          </p>
        </section>

        <footer className="mt-12 pt-6 border-t text-xs text-slate-500 text-center">
          © {new Date().getFullYear()} Fucan Personel Giyim · ACUTO 360
        </footer>
      </div>
    </div>
  );
}
